import moment from 'moment';
export default {
  methods: {
    calcPrice(startTime, endTime, premium) {
      //计算保费
      if (!premium) {
        return;
      }
      let day = (moment(moment(endTime).format('YYYY-MM-DD HH:mm:ss')).unix() * 1000 - moment(startTime).unix() * 1000) / (24 * 60 * 60 * 1000);
      let price = Math.round(Number(premium) * 100 / this.yearDays * Math.ceil(day)) / 100;
      return price;
    },
    calcRealyPrice(startTime, endTime, premium) {
      if (!premium) {
        return;
      }
      let day = (moment(moment(endTime).format('YYYY-MM-DD HH:mm:ss')).unix() * 1000 - moment(startTime).unix() * 1000) / (24 * 60 * 60 * 1000);
      let price = Number(premium) * 100 / this.yearDays * Math.ceil(day) / 100;
      return price;
    }
  }
};